export class NotificationComment {
    public NotificationId: string;
    public Comment: string;
    public UserPhone: string;
    public Created: Date;
    public UserName: string;
}
